(function () {
  'use strict';

  if (window.FellinoraSlideshowRevealLoaded) {
    return;
  }

  window.FellinoraSlideshowRevealLoaded = true;

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function setDelays(slideshow) {
    slideshow.querySelectorAll('[data-fsl-slide]').forEach(function (slide) {
      slide.querySelectorAll('[data-fsl-reveal]').forEach(function (item, index) {
        item.style.setProperty('--fsl-delay', Math.min(index * 100, 320) + 'ms');
      });
    });
  }

  function getActiveSlide(slideshow) {
    return slideshow.querySelector('[data-fsl-slide][aria-hidden="false"]') || slideshow.querySelector('[data-fsl-slide]');
  }

  function resetSlide(slide) {
    if (!slide) return;
    slide.querySelectorAll('[data-fsl-reveal]').forEach(function (item) {
      item.classList.remove('fsl-is-visible');
    });
  }

  function revealSlide(slide) {
    if (!slide) return;

    var items = slide.querySelectorAll('[data-fsl-reveal]');
    if (!items.length) return;

    items.forEach(function (item) {
      item.classList.remove('fsl-is-visible');
    });

    requestAnimationFrame(function () {
      items.forEach(function (item) {
        item.classList.add('fsl-is-visible');
      });
    });
  }

  function initSlideshow(slideshow) {
    if (!slideshow || slideshow.dataset.fslInitialized === 'true') {
      return;
    }

    slideshow.dataset.fslInitialized = 'true';
    setDelays(slideshow);

    if (reduceMotion || !('IntersectionObserver' in window)) {
      revealSlide(getActiveSlide(slideshow));
      return;
    }

    var hasEnteredViewport = false;
    var viewportObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) {
          return;
        }

        hasEnteredViewport = true;
        revealSlide(getActiveSlide(slideshow));
      });
    }, {
      threshold: 0.18,
      rootMargin: '0px 0px -8% 0px'
    });

    viewportObserver.observe(slideshow);

    var slideObserver = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.type !== 'attributes' || mutation.attributeName !== 'aria-hidden') {
          return;
        }

        var slide = mutation.target;
        if (slide.getAttribute('aria-hidden') === 'true') {
          resetSlide(slide);
          return;
        }

        if (hasEnteredViewport) {
          revealSlide(slide);
        }
      });
    });

    slideshow.querySelectorAll('[data-fsl-slide]').forEach(function (slide) {
      slideObserver.observe(slide, {
        attributes: true,
        attributeFilter: ['aria-hidden']
      });
    });
  }

  function initAll() {
    document.querySelectorAll('slideshow-component').forEach(initSlideshow);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll, { once: true });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var slideshow = event.target.querySelector('slideshow-component');
    if (slideshow) {
      initSlideshow(slideshow);
    }
  });
})();
